export default {
    email: 'sandra@example.com',
    client: 0,
    user: '',
    userGroup: '',
  avatarUrl: 'data:image/icons/user.png'
}
